var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7 45.8677L30.5 35.0677L41.3 45.8677L45.5 41.6677L34.7 30.8677L45.5 20.0677L41.3 15.8677L30.5 26.6677L19.7 15.8677L15.5 20.0677L26.3 30.8677L15.5 41.6677L19.7 45.8677ZM30.5 60.8677C26.35 60.8677 22.45 60.0797 18.8 58.5037C15.15 56.9277 11.975 54.7907 9.275 52.0927C6.575 49.3947 4.438 46.2197 2.864 42.5677C1.29 38.9157 0.502004 35.0157 0.500004 30.8677C0.498004 26.7197 1.286 22.8197 2.864 19.1677C4.442 15.5157 6.579 12.3407 9.275 9.64268C11.971 6.94468 15.146 4.80768 18.8 3.23168C22.454 1.65568 26.354 0.867676 30.5 0.867676C34.646 0.867676 38.546 1.65568 42.2 3.23168C45.854 4.80768 49.029 6.94468 51.725 9.64268C54.421 12.3407 56.559 15.5157 58.139 19.1677C59.719 22.8197 60.506 26.7197 60.5 30.8677C60.494 35.0157 59.706 38.9157 58.136 42.5677C56.566 46.2197 54.429 49.3947 51.725 52.0927C49.021 54.7907 45.846 56.9287 42.2 58.5067C38.554 60.0847 34.654 60.8717 30.5 60.8677Z",
    fill: "#E2564C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClose);
export default __webpack_public_path__ + "static/media/ic-close.d329b708c98806aad1c0101f4a9da0fd.svg";
export { ForwardRef as ReactComponent };